import { render, staticRenderFns } from "./CustomizeMetalS.vue?vue&type=template&id=e7a82c80&scoped=true"
import script from "./CustomizeMetalS.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalS.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalS.vue?vue&type=style&index=0&id=e7a82c80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a82c80",
  null
  
)

export default component.exports